import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
// import './api/mock'
import axios from '../src/api/index'
import URL from './api/url'
import { umeng } from '../utils/uma'
// 接入友盟
Vue.prototype.$umeng = umeng
Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(axios)
Vue.mixin({
  data () {
    return {
      URL: URL
    }
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
